/**
 * @file AdminHeader.js
 * @author Paola Bustos, Yevheniia Bazhmaieva, Simon Tenedero
 * @created 2025-07-07
 * @lastModified 2025-07-28
 * @description file contains the AdminHeader component with Archive Settings functionality
 */

/**
 * Header for AdminPanelPage, contains the configure button and archive settings button
 *
 * @param {Function} onArchiveSettingsClick - Callback function to open archive settings modal
 * @returns {JSX.Element} A header for the admin panel with a title, configure button, and archive settings button
 */
const AdminHeader = ({ onArchiveSettingsClick, setIsPreAssignModalOpen }) => {
  return (
    <div className="admin-header flex items-center py-4 px-5">
      <h1 className="font-bold text-lg mr-auto">Admin Panel</h1>

      <div className="flex items-center space-x-6">
        {/* Configure Button (existing) */}
        <button className="hover:text-white" onClick={setIsPreAssignModalOpen}>
          Pre-Assign
        </button>

        {/* Archive Settings Button (new) */}
        <button className="hover:text-white" onClick={onArchiveSettingsClick}>
          Archive
        </button>

        <button
          className="hover:text-white"
          onClick={() => console.log("clicked configure")} //TODO: implement configure functionality
        >
          Configure
        </button>
      </div>
    </div>
  );
};

export default AdminHeader;
